export default "cec71addabf687fa.svg"